import React from "react";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {Container} from "react-bootstrap";
import {mygaSession} from "../../../scripts/myga-session";
import {APP_SECTION} from "../../../scripts/constants";
import {saveApplication} from "../../../scripts/sync-manager";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";

class SubmitAppAgentFL extends React.Component {

  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      errorMessage: '',
      submission: mygaSession.getCurrentAppSubmission()
    };

  }

  validate = () => {
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Goals_ErrorMissingInformation
      });
      return false;
    }

    return true;
  };

  saveApplication = async () => {
    // populate finance object from fields
    let submission = this.state.submission;

    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.submission,submission);

    await saveApplication(APP_SECTION.submission)
  };

  handleChange = (field) => (e) => {
    let submission = this.state.submission;
    submission[field] = e.target ? e.target.value : e;

    this.setState({
      submission: submission,
      errorMessage:'',
    });
  };

  render() {
    return (
      <AppContentWrapper
        onBackPressed={this.saveApplication}
        onNextPressed={this.saveApplication}
        validateOnNext={this.validate}
        updatePage={this.props.updatePage}
        errorMessage={this.state.errorMessage}>

        <form className={'needs-validation'}
              ref={(form) => {
                this.pageForm = form;
              }}>
          <Container className={'pt-5 pl-5'}>
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('proposedAdvantagesFL')}
              data={this.state.submission}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('proposedDisadvantagesFL')}
              data={this.state.submission}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('basisOfRecommendationFL')}
              data={this.state.submission}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('ownerAnnuitantActiveDutyFL')}
              data={this.state.submission}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('agentRecommendedFL')}
              data={this.state.submission}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-5'}
              question={PageManager.getQuestionByName('timeKnowingOwnerFL')}
              data={this.state.submission}
              onChange={this.handleChange}
            />

          </Container>
        </form>

      </AppContentWrapper>
    )
  }
}

export default SubmitAppAgentFL